"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _OctaviWidgetManager = _interopRequireDefault(require("./panels/OctaviWidgetManager"));
var _OctaviMapScaleManager = _interopRequireDefault(require("./panels/OctaviMapScaleManager"));
var _OctaviWidgetManagerSelector = _interopRequireDefault(require("./panels/OctaviWidgetManagerSelector"));
var _OctaviMapWidgetManagerSelector = _interopRequireDefault(require("./panels/OctaviMapWidgetManagerSelector"));
var _OctaviMapScaleManagerSelector = _interopRequireDefault(require("./panels/OctaviMapScaleManagerSelector"));
var _OctaviComparisonPanel = _interopRequireDefault(require("./panels/OctaviComparisonPanel"));
var _OctaviFilterExtractPanel = _interopRequireDefault(require("./panels/OctaviFilterExtractPanel"));
var _OctaviCalendarPanel = _interopRequireDefault(require("./panels/OctaviCalendarPanel"));
var _OctaviTemporalFilterPanel = _interopRequireDefault(require("./panels/OctaviTemporalFilterPanel"));
var _OctaviSpatialFilterPanel = _interopRequireDefault(require("./panels/OctaviSpatialFilterPanel"));
var _OctaviSpatialFilterMapPanel = _interopRequireDefault(require("./panels/OctaviSpatialFilterMapPanel"));
var _ServiceLocator = _interopRequireDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
var _pages = require("chaire-lib-frontend/lib/components/pages");
const OctaviRightPanel = props => {
  const {
    t
  } = (0, _reactI18next.useTranslation)('octavi');
  const [needSubmit, setNeedSubmit] = _react.default.useState(false);
  const [dataSourceCollection, setDataSourceCollection] = _react.default.useState(_ServiceLocator.default.collectionManager.get('dataSources'));
  const onDataSourceCollectionUpdate = () => setDataSourceCollection(_ServiceLocator.default.collectionManager.get('dataSources'));
  _react.default.useEffect(() => {
    _ServiceLocator.default.eventManager.on('collection.update.dataSources', onDataSourceCollectionUpdate);
    _ServiceLocator.default.eventManager.on('taxi.filter.data.update', onFilterChange);
    // Reload the service collections at mount time, to make sure it is up to date
    if (dataSourceCollection !== undefined) {
      dataSourceCollection.loadFromServer(_ServiceLocator.default.socketEventManager, _ServiceLocator.default.collectionManager);
    }
    return () => {
      _ServiceLocator.default.eventManager.off('collection.update.dataSources', onDataSourceCollectionUpdate);
      _ServiceLocator.default.eventManager.off('taxi.filter.data.update', onFilterChange);
    };
  }, []);
  const onFilterChange = _react.default.useCallback(() => setNeedSubmit(true));
  const onSubmitForm = e => {
    e.preventDefault();
    _ServiceLocator.default.eventManager.emit('taxi.filter.submit');
    setNeedSubmit(false);
  };
  if (dataSourceCollection === undefined) {
    return /*#__PURE__*/_react.default.createElement(_pages.LoadingPage, null);
  }
  return /*#__PURE__*/_react.default.createElement("form", {
    id: "tr__form-taxi-activities-calendar",
    className: "tr__form-taxi-activities-calendar tr__form"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tr__form-section"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "_margin_bottom_small"
  }, /*#__PURE__*/_react.default.createElement(_OctaviFilterExtractPanel.default, {
    activeSection: props.activeSection
  }), /*#__PURE__*/_react.default.createElement(_OctaviWidgetManager.default, {
    activeSection: props.activeSection
  }), props.activeSection == "octaviMap" && /*#__PURE__*/_react.default.createElement(_OctaviMapScaleManager.default, {
    activeSection: props.activeSection
  }), /*#__PURE__*/_react.default.createElement(_OctaviWidgetManagerSelector.default, {
    activeSection: props.activeSection
  }), /*#__PURE__*/_react.default.createElement(_OctaviMapWidgetManagerSelector.default, {
    activeSection: props.activeSection
  }), /*#__PURE__*/_react.default.createElement(_OctaviMapScaleManagerSelector.default, {
    activeSection: props.activeSection
  })), props.activeSection == "octaviHighlights" && /*#__PURE__*/_react.default.createElement("div", {
    className: "_margin_bottom_small"
  }, /*#__PURE__*/_react.default.createElement(_OctaviComparisonPanel.default, {
    activeSection: props.activeSection
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "_margin_bottom_small"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "_bottom_border"
  }, /*#__PURE__*/_react.default.createElement("h3", null, t('octavi:filters:calendar:sectionName'))), /*#__PURE__*/_react.default.createElement(_OctaviCalendarPanel.default, {
    activeSection: props.activeSection
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "_margin_bottom_small"
  }, /*#__PURE__*/_react.default.createElement(_OctaviTemporalFilterPanel.default, {
    activeSection: props.activeSection
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "_margin_bottom_small"
  }, /*#__PURE__*/_react.default.createElement(_OctaviSpatialFilterPanel.default, {
    activeSection: props.activeSection
  }), /*#__PURE__*/_react.default.createElement(_OctaviSpatialFilterMapPanel.default, {
    activeSection: props.activeSection
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "_margin_bottom_small"
  }, /*#__PURE__*/_react.default.createElement("button", {
    title: !needSubmit ? t('octavi:filters:submit:filterNeedChangeToAllowSubmit') : '',
    className: `filter_submit ${needSubmit ? 'glowingButton' : ''}`,
    disabled: !needSubmit,
    type: "submit",
    onClick: onSubmitForm
  }, needSubmit ? t('octavi:filters:submit:applyNewFilters') : t('octavi:filters:submit:filterApplied')))));
};
OctaviRightPanel.propTypes = {
  activeSection: _propTypes.default.string
};
var _default = exports.default = OctaviRightPanel;